// ReportSummary — one-page summary (F8.2). Presentation.

import type { ValuationResult } from '@backsolve/shared-types';
import { usdPrecise, pct, isoDate } from '../../format/format';

export function ReportSummary({ result }: { result: ValuationResult }) {
  const h = result.headline;
  return (
    <div className="card">
      <div className="card-title">Report Summary</div>
      <div className="headline-grid">
        <div className="metric">
          <span className="metric-label">Valuation Date</span>
          <span className="metric-value" style={{ fontSize: 'var(--font-size-2)' }}>
            {isoDate(result.inputs.compliance.valuationDate)}
          </span>
        </div>
        <div className="metric">
          <span className="metric-label">Common FMV</span>
          <span className="metric-value">{usdPrecise(h.commonFmvPerShare)}</span>
        </div>
        <div className="metric">
          <span className="metric-label">Recommended Strike</span>
          <span className="metric-value">{usdPrecise(h.recommendedStrikePrice)}</span>
        </div>
        <div className="metric">
          <span className="metric-label">Discount</span>
          <span className="metric-value">
            {h.commonToPreferredDiscount !== null ? pct(h.commonToPreferredDiscount) : 'n/a'}
          </span>
        </div>
        <div className="metric">
          <span className="metric-label">Method</span>
          <span className="metric-value" style={{ fontSize: 'var(--font-size-2)' }}>
            {result.inputs.assumptions.method.toUpperCase()}
          </span>
        </div>
        <div className="metric">
          <span className="metric-label">DLOM</span>
          <span className="metric-value">{pct(result.inputs.discounts.dlomPercentage)}</span>
        </div>
      </div>
    </div>
  );
}
